import CampaignPlaceholder from "@/assets/images/campaign-placeholder.webp";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { HStack } from "@repo/components/src/ui/hstack";
import { Image } from "@repo/components/src/ui/image";
import { ListCampaignsWithReportQuery } from "@repo/graphql/documents/campaign/query.generated";
import { Link } from "expo-router";
import React from "react";

type CampaignNode =
  ListCampaignsWithReportQuery["campaign"]["list"]["edges"][number]["node"];

type Props = {
  campaign: CampaignNode;
  brandId: string;
};

const CampaignTitleCell = React.memo(({ campaign, brandId }: Props) => {
  const imageUrl = campaign.campaignmediaSet[0]?.media.url;
  const href = {
    pathname: "/app/(brands)/[brandId]/(main)/campaign/[campaignId]" as const,
    params: { brandId, campaignId: campaign.id },
  };

  return (
    <HStack space="md" className="items-center pr-3">
      <Image
        className="w-11 h-11 rounded-lg shrink-0"
        source={imageUrl ? { uri: imageUrl } : CampaignPlaceholder}
        contentFit="cover"
        size="none"
        alt={`${campaign.title} campaign image`}
      />
      <Link href={href} asChild>
        <Button
          variant="link"
          size="sm"
          className="flex-1 justify-start p-0 h-auto"
        >
          <ButtonText
            numberOfLines={2}
            className="text-left font-bold text-typography-900 hover:text-brand-600 hover:underline"
          >
            {campaign.title}
          </ButtonText>
        </Button>
      </Link>
    </HStack>
  );
});

CampaignTitleCell.displayName = "CampaignTitleCell";

export default CampaignTitleCell;
